// components/cards/GridCard.tsx
import React from 'react';
import { Box } from '@mui/material';

interface GridCardProps {
  icon: string;
  onClick: () => void;
}

export const GridCard: React.FC<GridCardProps> = ({ icon, onClick }) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        backgroundImage: `url(${icon})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '16px',
        width: '100%',
        aspectRatio: '177 / 162',
        cursor: 'pointer',
        transition: 'transform 0.2s',
        '&:hover': {
          transform: 'scale(0.97)',
        },
      }}
    />
  );
};